import React from 'react';
import s from './TimeComparison.module.css';

const TimeComparison: React.FC = () => {
    const tasks = [
        { task: 'Product Photo Editing', bySelf: '1–2 hours', withSimplee: '3 minutes' },
        { task: 'Background Cleanup', bySelf: '30 minutes', withSimplee: 'Instant' },
        { task: 'Lighting & Shadows', bySelf: '45 minutes', withSimplee: '2 minutes' },
        { task: 'Creating Branded Mockups', bySelf: '1 hour', withSimplee: '3 minutes' },
        { task: 'Adding Text & Branding', bySelf: '30 minutes', withSimplee: '1 minute' },
        { task: 'Exporting in Correct Sizes', bySelf: '15 minutes', withSimplee: '30 seconds' },
        { task: 'Writing Captions', bySelf: '20 minutes', withSimplee: '1 minute' },
        { task: 'Posting or Scheduling', bySelf: '15 minutes', withSimplee: 'Instant' },
    ];

    return (
        <section className={s.container}>
            <h2 className={s.title}>
                What takes hours,{' '}
                <span className={s.highlight}>SimpleeCreate does in minutes.</span>
            </h2>

            <div className={s.tableColumns}>
                {/* COLUMN: TASKS */}
                <div className={s.col}>
                    <div className={`${s.colHeader} ${s.headerTask}`}>Task</div>

                    {tasks.map((item, i) => (
                        <div key={i} className={`${s.colItem} ${s.task}`}>
                            {item.task}
                        </div>
                    ))}

                    <div className={`${s.colFooter} ${s.taskFoot}`}>Total</div>
                </div>

                {/* COLUMN: BY YOURSELF */}
                <div className={s.col}>
                    <div className={`${s.colHeader} ${s.headerNormal}`}>By Yourself</div>

                    {tasks.map((item, i) => (
                        <div key={i} className={`${s.colItem} ${s.normal}`}>
                            {item.bySelf}
                        </div>
                    ))}

                    <div className={`${s.colFooter} ${s.normalFoot} ${s.normal}`}>
                        <span>~ 6 hours</span>
                        <span className={s.note}>Or is 150 USD a shot with freelancers!</span>
                    </div>
                </div>

                {/* COLUMN: SIMPLEECREATE */}
                <div className={s.col}>
                    <div className={`${s.colHeader} ${s.headerSimplee}`}>With SimpleeCreate</div>

                    {tasks.map((item, i) => (
                        <div key={i} className={`${s.colItem} ${s.simplee}`}>
                            {item.withSimplee}
                        </div>
                    ))}

                    <div className={`${s.colFooter} ${s.simpleeFooter}`}>~ 10 minutes</div>
                </div>
            </div>
        </section>
    );
};

export default TimeComparison;
